import { FC } from 'react';
import { UseFormRegister } from 'react-hook-form';
import { Input } from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
};

/**
 * 法人番号のフォームのベースです。
 * NOTE: Chakra の Text は非制御コンポーネントなので、react-hook-form の register でフォーム化しています。
 */
export const CorporateNumberFormBase: FC<Props> = ({ register }) => (
  <Input
    id="corporateNumber"
    type="text"
    {...register('corporateNumber', {
      pattern: {
        value: /^[0-9]{13}$/,
        message: '顧客番号は 13 桁の半角数字です。',
      },
    })}
  />
);
